import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authenticated-footer',
  templateUrl: './authenticated-footer.component.html',
  styleUrls: ['./authenticated-footer.component.scss'],
})
export class AuthenticatedFooterComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
